module.exports = __webpack_public_path__ + "img/ptz-icon2.d0120f47.svg";